import { Link } from "react-router-dom";

import type { DueBucket, TodayTask } from "../lib/task-model";

interface TaskRowProps {
  task: TodayTask;
  disabled: boolean;
  pending: boolean;
  canManage?: boolean;
  onComplete: (task: TodayTask) => void;
}

const dueLabels: Record<DueBucket, string> = {
  OVERDUE: "已逾期",
  TODAY: "今天",
  UNDATED: "未排日期",
};

export function TaskRow({ task, disabled, pending, canManage = true, onComplete }: TaskRowProps) {
  return (
    <li className="task-row">
      <button
        type="button"
        className="task-check"
        aria-label={`完成「${task.title}」`}
        disabled={disabled || pending || !canManage}
        onClick={() => onComplete(task)}
      >
        <span aria-hidden="true">{pending ? "···" : ""}</span>
      </button>
      <div className="task-copy">
        <p className="task-title">{task.title}</p>
        <div className="task-meta">
          <span className={`due-label due-${task.dueBucket.toLowerCase()}`}>
            {dueLabels[task.dueBucket]}
            {task.hasDueTime && task.dueAt ? ` ${taipeiTime(task.dueAt)}` : ""}
          </span>
          {task.priority === "HIGH" ? <span>高優先</span> : null}
          <span>{task.points} 點</span>
        </div>
      </div>
      {canManage ? (
        <Link
          className="task-edit-link"
          to={`/tasks/${encodeURIComponent(task.templateId)}/edit`}
          aria-label={`編輯「${task.title}」`}
        >
          編輯
        </Link>
      ) : null}
    </li>
  );
}

function taipeiTime(timestamp: string) {
  return new Intl.DateTimeFormat("zh-TW", {
    timeZone: "Asia/Taipei",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(new Date(timestamp));
}
